import { createContext } from 'react'

import type { AppConfiguration } from './types'

/**
 * Context used for configuring Festina Life apps. Allows app builders to dynamically define the components, hooks and
 * services used by the apps.
 */
export const context = createContext<AppConfiguration | null>(null)
